exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\r\n    cursor: pointer;\r\n}\r\n\r\ninput[type=\"color\"] {\r\n    padding: 0 0.25em;\r\n    width: 6em;\r\n    border-radius: 0.25em;\r\n}\r\n\r\n.color-preview {\r\n    width: 6em;\r\n    height: 2em;\r\n    border-radius: 0.25em;\r\n    box-shadow: 1px 1px 3px rgba(0,0,0,0.15);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/src/app/components/color-shade/color-shade/color-shade.component.css
// module id = ../../../../../src/app/components/color-shade/color-shade/color-shade.component.css
// module chunks = 0